import * as React from 'react';
import { css } from 'glamor'
import * as _ from 'lodash'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "./customDatePickerWidth.css"
import moment from 'moment'
import ReactDOM from 'react-dom';
import { Form } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';
import { isEmpty } from '../../utils/validator';

const style = {

    btnClear: css({
        "cursor": "pointer",
        "top": "10px",
        "position": "absolute",
        "right": "10px",
    })
}

const $el = document.querySelector("body");
const PopperContainer = ({ children }) => (
    ReactDOM.createPortal(
        children,
        $el,
    )
);

const CalendarContainer = ({ children }) => children ? (
    ReactDOM.createPortal(React.cloneElement(children, {
        className: "YOUR_DATEPICKER_CSS_CLASS_HERE react-datepicker-popper"
    }), document.body)
) : null;

const colors = {
    red: "#cc0000",
    green: "#198c19",
}

interface ErrorT {
    msg: string
    show: boolean
    status: boolean
}


const PropsError: ErrorT = {
    msg: "",
    show: false,
    status: false,
}

interface IInputDatePickerProps extends ReactDatePickerProps {
    id?: string
    selectedDate?: string
    onChangeDate?(selected: Date | string | null): void
    //selected?: string
    validated?: boolean
    required?: boolean
    textFeedBack?: string
    dropdownMode?: 'scroll' | 'select'
    className?: string
    //onChange?(selected: any): void
    placeholder?: string
    btnClear?: boolean
    style?: React.CSSProperties
    dateFormat?: string
    todayButton?: string
    disabled?: boolean
    readonly?: boolean
}

const InputDatePicker: React.FC<IInputDatePickerProps> = (props) => {
    const [selected, setSelected] = React.useState(null)
    const [validated, setValidated] = React.useState(false)
    const [error, setError] = React.useState(PropsError)

    React.useEffect(() => {


        if (!isEmpty(props.selectedDate)) {
            try {
                console.log('props.selectedDate', props.selectedDate)
                let newValue = moment(props.selectedDate).isValid() ? moment(props.selectedDate).toDate() : ""
                // let newValue = new Date(props.selected)
                setSelected(newValue)
            } catch (error) {
                console.log('InputDatePicker->error', error)
            }

        } else {
            setSelected("")
        }
    }, [props.selectedDate])

    const ref = React.useRef()

    React.useEffect(() => {
        if (props.validated != undefined && props.validated == true && validated == false) {
            setValidated(true)
            checkValidity(selected)
        }

    }, [props.validated])


    const checkValidity = (_selected) => {

        setError(validation(_selected))
    }

    const onChangeRaw = (e) => {
        e.preventDefault();

    };
    const validation = (value): ErrorT => {
        let error = {
            msg: "",
            show: false,
            status: false,
        }

        if (props.required === true && (value == null || value == "" || value == undefined)) {

            error.show = true;
            error.msg = props.textFeedBack
            // selectRef.setCustomValidity(error.msg)
            return error

        }


        return error

    }

    const onChange = (val) => {
        validation(val)
        // if (props.onChange) {
        //     props.onChange(val);
        // }
        if (props.onChangeDate) {
            props.onChangeDate(val);
        }
        setSelected(val)
        checkValidity(val)

    }

    const handleBlur = () => {
        // if (props.onChange) {
        //     props.onChange(props.selected);
        // }
        if (props.onChangeDate) {
            props.onChangeDate(props.selected);
        }

    };

    const renderError = () => {

        if (error.show) {
            return (
                <Form.Text className="" style={{ color: error.status ? colors.green : colors.red }}>
                    {props.textFeedBack}
                </Form.Text>
            )
        }
    }

    const clearInput = () => {
        onChange("")
    }
    let className = `form-control ${props.className}`

    return (
        <div style={{
            position: (props.btnClear && _.isDate(selected)) ? "relative" : "inherit"
        }}>
            <DatePicker
                // {...props}
                selected={selected}
                className={className}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode={props.dropdownMode}
                onChange={onChange}
                ref={ref}
                disabled={props.disabled}
                readOnly={props.readOnly}
                onChangeRaw={onChangeRaw}
                placeholderText={props.placeholder}
                popperContainer={CalendarContainer}
            />
            {(props.btnClear && _.isDate(selected)) && <span
                onClick={clearInput}
                style={{
                    cursor: "pointer",
                    bottom: 10,
                    position: "absolute",
                    right: 10,
                }}>
                <i className="fa fa-close text-danger"></i>
            </span>}
            {renderError()}
        </div>
    )

}

InputDatePicker.defaultProps = {
    required: false,
    className: "",
    placeholder: "",
    dropdownMode: "select",
    textFeedBack: "Required.",
    validated: null,
    //menuPortalTarget:"",
}

export default InputDatePicker;
